import { createRoute, redirect } from '@tanstack/react-router';
import { getSession } from '../lib/auth-store';
import { HomePage } from './HomePage';
import { rootRoute } from './root-route';

/** Installed PWA (standalone) opened by a caddy: go straight to score entry. */
function installedCaddy(): boolean {
  try {
    const standalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true;
    return standalone && getSession('CADDY') !== null;
  } catch {
    return false;
  }
}

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    if (installedCaddy()) throw redirect({ to: '/caddy' });
  },
  component: HomePage,
});
